// announcementServices.js
import createEntityService from './entityServiceFactory';

const service = createEntityService({
    endpoint: '/announcements.php',
    idParam: 'announcement_id',
    viewAction: 'getAnnouncementViews',
    viewReturnKey: 'announcementId',
});

export const markAnnouncementAsRead  = (id, userId)              => service.markAsRead(id, userId);
export const fetchAnnouncements      = (userId, isDirector, hideRead, page, pageSize) => service.fetch(userId, isDirector, hideRead, page, pageSize);
export const getAnnouncementViews    = (ids)                     => service.getViews(ids);
export const addAnnouncement         = (formData)                => service.add(formData);
export const removeAnnouncement      = (id)                      => service.remove(id);
export const updateAnnouncement      = (formData)                => service.update(formData);
